import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RequestKeys,
} from '../hooks/useRequest'

type ContainerNoteRequests = {
    domainName: string,
    filterRequest: RequestConfigFunction<{
        containerId: number,
        sorting: Record<string, any>,
        rows: number,
        start: number,
    }>,
    [RequestKeys.getContainerNoteDetails]: RequestConfigFunction<{id: number}>,
    create: RequestConfigFunction<undefined>,
}

const containerNoteRequests: ContainerNoteRequests = {
    domainName: 'ContainerNoteView',
    filterRequest: ({
        containerId,
        sorting,
        rows,
        start,
    }) => {
        return {
            url: 'container/containernote/filter-request/all',
            method: 'POST',
            data: {
                includeFilters: {
                    containerId: [containerId],
                },
                ...sorting,
                rows,
                start,
            },
        }
    },
    [RequestKeys.getContainerNoteDetails]: ({
        id,
    }) => {
        return {
            url: `container/containernote/${id}`,
            method: 'GET',
        }
    },
    create: () => {
        return {
            url: 'container/containernote',
            method: 'POST',
            domainName: 'ContainerNoteView',
        }
    },
}

export default containerNoteRequests
